import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Resources.css';

const ResourceItem = ({ title, link, image, label }) => (
  <div className="resource-item" data-aos="fade-up">
    <div className="resource-img-wrapper">
      <img src={image} alt={title} className="resource-img" loading="lazy" />
    </div>
    <h3>{title}</h3>
    {link && (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    )}
  </div>
);

const Resources = () => {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init({ duration: 1000, offset: 100 });
  }, []);

  const resourcesData = [
    {
      title: 'React Documentation',
      description: 'Official documentation for React.js. A must-read for React developers.',
      link: 'https://reactjs.org/',
      image: '/Resource/item1.png',
    },
    {
      title: 'Python',
      description: 'The official Python programming language website.',
      link: 'https://www.python.org/',
      image: '/Resource/python.png',
    },
    {
      title: 'Java Programming',
      description: 'Resources and guides for Java programming.',
      link: 'https://www.oracle.com/java/',
      image: '/Resource/java.png',
    },
    {
      title: 'NestJS Documentation',
      description: 'Learn to build efficient, reliable, and scalable server-side applications using NestJS.',
      link: 'https://docs.nestjs.com/',
      image: '/Resource/nest.png',
    },
    {
      title: 'Amazon Web Services (AWS)',
      description: 'Cloud computing services by Amazon for building, deploying, and managing applications.',
      link: 'https://aws.amazon.com/',
      image: '/Resource/Amazon_Web_Services.png',
    },
    {
      title: 'Rust Programming Language',
      description: 'Documentation for Rust programming language.',
      link: 'https://www.rust-lang.org/',
      image: '/Resource/rust.png',
    },
  ];

  return (
    <div id="Resources" className="resources-container">
      <div className="resources-list">
        {resourcesData.map((resource, index) => (
          <ResourceItem label={t('agency.resources')} key={index} {...resource} />
        ))}
      </div>
    </div>
  );
};

export default Resources;
